{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "vault",
  "features": [
    {
      "id": "records-iq",
      "name": "recordsIQ / vaultIQ",
      "summary": "Search and reason across aircraft records.",
      "availability": "AVAILABLE"
    },
    {
      "id": "oem-iq",
      "name": "oemIQ",
      "summary": "OEM manuals matched to each aircraft.",
      "availability": "AVAILABLE"
    },
    {
      "id": "tail-record",
      "name": "Permanent Tail Record",
      "summary": "Governed history for every aircraft.",
      "availability": "AVAILABLE"
    },
    {
      "id": "evidence-packages",
      "name": "Evidence Packages",
      "summary": "Audit, pre-buy, and handoff packages.",
      "availability": "AVAILABLE"
    },
    {
      "id": "controlled-sharing",
      "name": "Controlled Sharing",
      "summary": "Share evidence across organizations securely.",
      "availability": "AVAILABLE"
    }
  ]
}